









































































import { ValidationObserver } from "vee-validate";
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import ModelSetter from "../../../../../../Mixins/ModelSetter";
import { warningNotificationWrapper } from "../../../../../../logic/helpers/NotificationService";
import isTelegramWebview from "../../../../../../shared/utils/isTelegramWebview";
import SwitchInput from "../../../../../Pi/fields/SwitchInput/SwitchInput.vue";
import TextInput from "../../../../../Pi/fields/TextInput/TextInput.vue";
import MediaManager from '../../logic/MediaManager'
import { captureScreenshot } from "../../logic/captureScreenshot";
import {
  filesWithPreviewMapper,
  FilesWithPreviewToUpload,
  FileWithPreviewToUpload
} from "../../logic/filesToUpload";
import { FileType } from '../../types'
import InputUpload from "../InputUpload.vue";
import UploadThumbnail from "../Thumbnail/UploadThumbnail.vue";

@Component({
  methods: {
    captureScreenshot
  },
  data() {
    return {
      FileType
    }
  },
  components: {
    SwitchInput,
    UploadThumbnail,
    InputUpload,
    TextInput,
    ValidationObserver
  }
})
export default class MediaUploader extends Mixins(ModelSetter) {
  @Prop() mediaManager!: MediaManager

  @Emit()
  closeModal(): void {
    return
  }

  isThumbnailModalOpen = false

  filesToUpload: FilesWithPreviewToUpload = []

  model = {
    messagePreviewUrl: ''
  }

  get hideInSpoiler() {
    if (this.mediaManager.selectedTypeIsAnimation) {
      return this.mediaManager.selectedType === FileType.SpoilerAnimation
    } else if (this.mediaManager.selectedTypeIsImage) {
      return this.mediaManager.selectedType === FileType.SpoilerImage
    } else if (this.mediaManager.selectedTypeIsVideo) {
      return this.mediaManager.selectedType === FileType.SpoilerVideo
    }

    return false
  }

  set hideInSpoiler(value: boolean) {
    if (this.mediaManager.selectedTypeIsAnimation) {
      this.mediaManager.selectedType = value ? FileType.SpoilerAnimation : FileType.Animation
    } else if (this.mediaManager.selectedTypeIsImage) {
      this.mediaManager.selectedType = value ? FileType.SpoilerImage : FileType.Image
    } else if (this.mediaManager.selectedTypeIsVideo) {
      this.mediaManager.selectedType = value ? FileType.SpoilerVideo : FileType.Video
    }
  }

  get multipleUpload(): boolean {
    if (this.mediaManager.selectedType) {
      return ![ FileType.MessagePreview, FileType.Voice, FileType.VideoNote, FileType.Animation, FileType.SpoilerAnimation ].includes(this.mediaManager.selectedType)
    }
    return true
  }

  get acceptedTypes(): string | null {
    const { selectedType } = this.mediaManager

    if (!isTelegramWebview() && selectedType) {
      if ([ FileType.Video, FileType.SpoilerVideo, FileType.VideoNote ].includes(selectedType)) {
        return 'video/*'
      } else if ([ FileType.Audio, FileType.Voice ].includes(selectedType)) {
        return 'audio/*'
      } else if (selectedType === FileType.MessagePreview) {
        return 'image/*, video/*'
      } else if (this.mediaManager.selectedTypeIsAnimation) {
        return 'image/gif, video/*'
      } else if (this.mediaManager.selectedTypeIsImage) {
        return 'image/*'
      } else {
        return null
      }
    }

    return null
  }

  get uploadAreaTitle() {
    if (this.mediaManager.selectedTypeIsImage) {
      return this.$t('upload_media_area_with_copy_paste').toString()
    }

    return this.$t('upload_media_area_default').toString()
  }

  handlePaste(evt: ClipboardEvent): void {
    if (this.mediaManager.selectedType && [ FileType.Image, FileType.MessagePreview, FileType.TopMessagePreview ].includes(this.mediaManager.selectedType)) {
      const { clipboardData } = evt

      if (clipboardData && clipboardData.files.length && clipboardData.files[0].type.includes('image/')) {
        this.onFileInputChange([ clipboardData.files[0] ] as unknown as FileList, 'paste')
      }
    }
  }

  uploadMessagePreviewUrl() {
    this.mediaManager.prepareMessagePreviewUrl(this.model.messagePreviewUrl)

    this.closeModal()
  }

  onLimitCallback = () => warningNotificationWrapper(this.$t('warning').toString(), this.$t('message_editor_files_to_upload_limit_has_reached', { limit: this.mediaManager.uploadLimit() }).toString())

  onFileInputChange(files: FileList, source: any): void {

    if (this.mediaManager.selectedTypeIsAnimation
      || this.mediaManager.selectedType === FileType.Audio
      || this.mediaManager.selectedType === FileType.Document
      || this.mediaManager.selectedTypeIsVideo
      || this.mediaManager.selectedType === FileType.VideoNote) {
      let uploadInfo: FileWithPreviewToUpload['uploadInfo'] = {}

      if (this.mediaManager.selectedTypeIsVideo || this.mediaManager.selectedTypeIsAnimation) {
        uploadInfo = {
          type: this.mediaManager.selectedType!,
          spoiler: this.hideInSpoiler
        }
      }

      this.filesToUpload = filesWithPreviewMapper(files, uploadInfo)
    } else {
      this.mediaManager.upload(filesWithPreviewMapper(files), this.onLimitCallback)

      this.closeModal()
    }
  }

  done() {
    this.mediaManager.upload(this.filesToUpload, this.onLimitCallback)
    this.filesToUpload = []

    this.closeModal()
  }

  mounted(): void {
    document.addEventListener('paste', this.handlePaste)
  }

  destroyed(): void {
    document.removeEventListener('paste', this.handlePaste)
  }
}
